var exports = {
  "i": "xaee3c4fa--ea33d0--wrapper",
};

module.exports = exports;
